import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

export function useWebSocket(config = {}) {
    const pusherConfig = config.pusher || window.AUDIENCE_CONFIG?.pusher || {}
    
    const createEcho = () => {
        if (!pusherConfig.key) {
            console.warn('No Pusher configuration provided for WebSocket')
            return null
        }

        console.log('Creating Echo instance with config:', pusherConfig)

        // Set up Pusher
        window.Pusher = Pusher

        const echo = new Echo({
            broadcaster: 'pusher',
            key: pusherConfig.key,
            cluster: pusherConfig.cluster,
            wsHost: pusherConfig.wsHost,
            wsPort: pusherConfig.wsPort || 80,
            wssPort: pusherConfig.wssPort || 443,
            forceTLS: pusherConfig.forceTLS !== false,
            enabledTransports: ['ws', 'wss'],
            disableStats: true,
        })

        // Debug connection events
        if (echo.connector && echo.connector.pusher) {
            echo.connector.pusher.connection.bind('connected', () => {
                console.log('WebSocket connected successfully')
            })

            echo.connector.pusher.connection.bind('disconnected', () => {
                console.log('WebSocket disconnected')
            })

            echo.connector.pusher.connection.bind('error', (error) => {
                console.error('WebSocket connection error:', error)
            })

          
        }
        console.log("✅ Echo instance created")
        console.log(echo)
        return echo
    }

    const subscribeToChannel = (echo, channelName, events = {}) => {
        if (!echo) {
            console.warn('Echo instance not available for channel subscription')
            return null
        }

        console.log('Subscribing to channel:', channelName)
        const channel = echo.channel(channelName)

        // Bind all provided events
        Object.entries(events).forEach(([eventName, handler]) => {
            console.log(`Binding event: ${eventName}`)
            // Use bind for custom event names (with dots), listen for class names
            if (eventName.includes('.')) {
                // Custom event name - use direct Pusher binding
                if (echo.connector && echo.connector.pusher) {
                    const pusherChannel = echo.connector.pusher.channels.channels[`private-${channelName}`] || 
                                        echo.connector.pusher.channels.channels[channelName]
                    if (pusherChannel) {
                        console.log("Binding custom event via Pusher:", pusherChannel)
                        pusherChannel.bind(eventName, handler)
                        console.log("Bound custom event via Pusher:", eventName)
                    }
                }
            } else {
                // Class-based event - use Laravel Echo listen
                channel.listen(eventName, handler)
            }
        })

        return channel
    }

    return {
        createEcho,
        subscribeToChannel
    }
}